import { httpRequest } from '../../../app/common/util/api-common.util';

class ProtocoloAPI {
  static ApagarRequisicaoImuno(laudo, requisicao) {
    return httpRequest(
      `Lamina/${laudo}/${requisicao}/ApagarRequisicaoImuno`,
      'DELETE'
    );
  }

  static GetFavoritoRequisicaoById(){

    ///RequisicaoProtocolo

  }

  static GetFavoritoRequisicaoByUsuarioId(){
    /// passar o id usuário logado no sistema

    httpRequest(``, 'GET').then((resp) => {
      return resp.data
    })


  }

  static PostFavoritoRequisicaoProtocolo(){

     httpRequest(``, 'POST', {}).then(resp => {
      return resp.data
    })

  } 

  static SetFavoritoDefault(){

    httpRequest(``, 'PATCH', {}).then(response => {
      return response.data;
    })

  }

  static DeleteFavorito(){

    httpRequest(``, 'Delete', {}).then(response => {
      return response.data;
    })

  }
  
}

export default ProtocoloAPI;



// WEBPACK FOOTER //
// ./src/app/common/protocolo/protocolo.api.js